import React, { ChangeEvent, MouseEvent, KeyboardEvent } from 'react';
import { useMediaQuery } from '@mui/material';
import './index.css';

interface SearchBarProps {
    searchValue: string;
    onSearchValueChange: (e: ChangeEvent<HTMLInputElement>) => void;
    onClearSearchValue: (e: MouseEvent<HTMLInputElement>) => void;
    onKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
    isOpen: boolean;
    onSearch: (val: string) => void;
    setIsOpen: (isOpen: boolean) => void;
}

export default function SearchBar(props: SearchBarProps) {
    const {
        searchValue, onSearchValueChange, onClearSearchValue, onKeyDown, isOpen, setIsOpen, onSearch
    } = props;
    const isMobile = useMediaQuery('(max-width:800px)');

    if (!isOpen && isMobile) {
        return (
            <button
                type='button'
                onClick={() => setIsOpen(true)}
                className='search-bar__icon search-bar__open-search-icon'
                aria-label='Open Search'
            />
        );
    }

    return (
        <div className='search-bar'>
            <div className={`search-bar__container ${searchValue && 'has-content'}`}>
                <input
                    placeholder='Search'
                    autoComplete='off'
                    type='text'
                    value={searchValue}
                    onChange={onSearchValueChange}
                    onKeyDown={onKeyDown}
                />
                {searchValue && (
                    <div
                        role='button'
                        tabIndex={0}
                        onClick={onClearSearchValue}
                        onKeyDown={onKeyDown}
                        className='search-bar__icon clear-icon'
                        aria-label='Clear Search'
                    />
                )}
                <div
                    role='button'
                    tabIndex={0}
                    onClick={() => onSearch(searchValue)}
                    onKeyDown={onKeyDown}
                    className='search-bar__icon search-icon'
                    aria-label='Search'
                />
            </div>
            {isOpen && isMobile && (
                <div
                    role='button'
                    tabIndex={0}
                    className='search-bar__icon search-bar__close-search-icon'
                    onClick={() => setIsOpen(false)}
                    onKeyDown={() => {}}
                    aria-label='Close Search'
                />
            )}
        </div>
    );
}
